import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import http from '../../utils/http';
import API_ENDPOINTS from '../../utils/api-endpoints';
import { CRM_CREATORS_STORE_CONSTANTS } from '../../../../store/constants.store';
import { selectIsCompanyUpdate } from '../../../../store/App/crm/companies/crm.companies.selectors';
import { selectIsUpdateCrmCreator } from '../../../../store/App/crm/creators/crm.creators.selectors';
import { selectIsUpdateCrmProject } from '../../../../store/App/crm/projects/crm.projects.selectors';
import { selectIsUpdateCrmNotes } from '../../../../store/App/crm/notes/crm.notes.selector';
import { selectIsUpdateCrmTasks } from '../../../../store/App/crm/tasks/crm-tasks-selector';

const getFilteredCreators = async ({ queryKey }) => {
	const [_key, _params] = queryKey;
	const data = await http.post(`${API_ENDPOINTS.FILTER_CREATORS}`, _params);
	console.log("creatorsAll",data);
	return data?.data;
};

const useGetFilteredCreators = (options) => {
	const dispatch = useDispatch();
	const isTaskUpdated = useSelector(selectIsUpdateCrmTasks);
	const isCompanyUpdated = useSelector(selectIsCompanyUpdate);
	const isNOTEupdated = useSelector(selectIsUpdateCrmNotes);
	const isCreatorUpdated = useSelector(selectIsUpdateCrmCreator);
	const isProjectUpdated = useSelector(selectIsUpdateCrmProject);

	const onSuccess = (data) => {
		dispatch({
			type: CRM_CREATORS_STORE_CONSTANTS.SET_CRM_CREATOR_DATA,
			payload: data?.data,
		});
	};
	return useQuery(
		[
			API_ENDPOINTS.FILTER_CREATORS,
			options,
			isCompanyUpdated,
			isCreatorUpdated,
			isProjectUpdated,
			isNOTEupdated,
			isTaskUpdated,
		],
		getFilteredCreators,
		{
			onSuccess,
			enabled: !!options,
		},
	);
};

export { useGetFilteredCreators, getFilteredCreators };
